import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import * as m from '~/paraglide/messages'
import { Label } from '~/shared/ui/label'
import { Switch } from '~/shared/ui/switch'

export function ThemeSwitch() {
  const { setTheme, resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const isDark = mounted && resolvedTheme === 'dark'

  return (
    <div className="flex items-center justify-between gap-4">
      <Label className="font-medium text-sm">{m.theme()}</Label>
      <div className="flex items-center gap-2">
        <Sun className="h-4 w-4 text-muted-foreground" />
        <Switch
          checked={isDark}
          onCheckedChange={(checked) => setTheme(checked ? 'dark' : 'light')}
          disabled={!mounted}
          aria-label={m.toggleTheme()}
        />
        <Moon className="h-4 w-4 text-muted-foreground" />
      </div>
    </div>
  )
}
